import React from "react";
import { Avatar } from "@mui/material";
import { avatarForProfile } from "../images";

/**
 * Reusable avatar that
 *   • uses avatarForProfile() to pick the right source
 *   • removes blue background + adds padding for the branded icon
 *
 * @param {object}  profile   the AIProfile (or null)
 * @param {number|object}  size      diameter in px (defaults to 48) or responsive object
 */
export default function ProfileAvatar({ profile, size = 48 }) {
  const src = avatarForProfile(profile);
  const isBrandIcon = src && /\/logo\.ico$/i.test(src);

  // Handle responsive sizing
  const getResponsiveSize = (sizeValue) => {
    if (typeof sizeValue === "object") {
      return sizeValue;
    }
    return sizeValue;
  };

  const getResponsivePadding = (sizeValue) => {
    if (typeof sizeValue === "object") {
      // For responsive objects, use the largest size for padding calculation
      const maxSize = Math.max(...Object.values(sizeValue));
      return isBrandIcon ? maxSize * 0.025 : 0;
    }
    return isBrandIcon ? sizeValue * 0.025 : 0;
  };

  const getResponsiveFontSize = (sizeValue) => {
    if (typeof sizeValue === "object") {
      // For responsive objects, use the largest size for font calculation
      const maxSize = Math.max(...Object.values(sizeValue));
      return maxSize * 0.45;
    }
    return sizeValue * 0.45;
  };

  return (
    <Avatar
      src={src}
      imgProps={{ style: { objectFit: "contain" } }}
      sx={{
        width: getResponsiveSize(size),
        height: getResponsiveSize(size),
        bgcolor: isBrandIcon ? "white" : "primary.main",
        p: getResponsivePadding(size),
        fontSize: getResponsiveFontSize(size),
      }}
    >
      {profile?.name?.[0] || "?"}
    </Avatar>
  );
}
